import { Box, Button, ButtonGroup, Dialog, IconButton, InputAdornment, Stack, TableCell, TextField, Typography } from "@mui/material"
import Header from "../Components/ui/Header"
import SorTableCheckable from "../Components/ui/sortable-checkable"
import { useContext, useEffect, useState } from "react"
import { API } from "../conf"
import { Context } from "../App"
import { Cached, CheckCircle, Close, DeleteForever, FileDownload, FileUpload, InfoOutlined, Money, MoneyOff, Report, Search } from "@mui/icons-material"
import EgliseInfo from "./db-eglise-info"
import EgliseReset from "./db-eglise-reset"

export default function DBManager() {
    const {updateConnect} = useContext(Context)
    const [eglises, setEglises] = useState([])
    const [selectItems, setItems] = useState([])
    const [eglise, setEglise] = useState('')
    const [open, setOpen] = useState(false)
    const [action, setAction] = useState('')
    const [searchInput, setShearch] = useState('')

    const table = [
        {header: "Nom", sortable: true, sortBy:(el)=>el.nom.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{row.nom}</TableCell>},
        {header: "Adresse", sortable: true, sortBy:(el)=>(el.adresse1+' '+el.adresse2).toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{row.adresse1+', '+row.adresse2}</TableCell>},
        {header: "Code postal", sortable: true, sortBy:(el)=>el.zip_code, row: (row, index)=><TableCell key={index} sx={{maxWidth:'70px', textAlign:'center'}}>{row.zip_code}</TableCell>},
        {header: "Commune", sortable: true, sortBy:(el)=>el.commune.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'150px'}}>{row.commune}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'180px', textAlign:'end'}} >
            <IconButton aria-label="informations complémentaires" onClick={()=>{setEglise(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setEglise(row); manage_dialog(true, 'delete')}}><DeleteForever fontSize="small"/></IconButton>
            <IconButton aria-label="reinitialiser" onClick={()=>{setEglise(row); manage_dialog(true, 'reset')}}><Cached fontSize="small"/></IconButton>
            <IconButton aria-label="solde compte" onClick={()=>{setEglise(row); manage_dialog(true, 'liaison solde')}}><MoneyOff fontSize="small"/></IconButton>
            <IconButton aria-label="export" onClick={()=>{setEglise(row); manage_dialog(true, 'export')}}><FileUpload fontSize="small"/></IconButton>
            <IconButton aria-label="import" onClick={()=>{setEglise(row); manage_dialog(true, 'import')}}><FileDownload fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.nom+' '+item.adresse1+' '+item.adresse2+' '+item.zip_code+' '+item.commune
    }

    function manage_dialog(status, action='') {
        setOpen(status)
        setAction(action)
        if(!status) {
            setEglise('')
        }
    }

    async function showResult(result) {
        manage_dialog(true, result ? 'success' : 'echec')
        await new Promise(resolve => setTimeout(resolve, 3000))
        manage_dialog(false)
    }

    async function handleLaisonSoldeCalcule() {
        fetch(API.concat(`/comptes/${eglise.number}/liaison/solde`),{method:'PATCH', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    showResult(true)
                }
            }
        })
    }

    useEffect(()=>{
        fetch(API.concat('/eglises'),{method:'GET', headers:{
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + sessionStorage.getItem('token')
        }}).then(async response=>{
            const token = response.headers.get('x-auth-token')
            if(response.status === 401) {
                sessionStorage.clear()
                updateConnect(false)
            }else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'))
                }
                if (response.status === 200) {
                    const json = await response.json()
                    setEglises(json)
                }
            }
        })
    //eslint-disable-next-line
    },[])

    return(
        <Box display='flex' flex={1} flexDirection='column'>
            <Header />
            <Typography variant="h4" align="center" marginY={5}>Gestionnaire de Base de données</Typography>

            <ButtonGroup variant="outlined" disabled={selectItems.length<=0}
            sx={{alignSelf:'flex-end', marginRight:3, marginBottom:2}} aria-label="text button group">
                <Button>supprimer</Button>
                <Button onClick={()=>manage_dialog(true, 'reset_many')}>Réinitialiser</Button>
                <Button>Export</Button>
                <Button>import</Button>
            </ButtonGroup>

            <TextField placeholder="Rechercher une église" size="small" 
            sx={{alignSelf:'center', width:'60%', minWidth:'400px', marginBottom:2}} 
            value={searchInput} onChange={e=>setShearch(e.target.value)}
            InputProps={{endAdornment: (<InputAdornment position="end"><Search/></InputAdornment>)}}/>

            <Stack direction='row' spacing={2} paddingInline={3} paddingBottom={2}>
                <SorTableCheckable {...{data:eglises.filter(item=> normalize(get_searchable(item)).includes(normalize(searchInput))), table, selectItems,setItems, rowsPerPage:100, rowsPerPageOptions:[30,50,100,300]}}/>
            </Stack>

            <Dialog open={open} onClose={()=>manage_dialog(false)} fullWidth maxWidth={['echec', 'success'].includes(action)?'xs':'sm'}>
                {!['echec', 'success'].includes(action)&&<IconButton sx={{alignSelf:'end', marginRight:1, marginTop:1}} onClick={()=>manage_dialog(false)}><Close/></IconButton>}
                {action === 'info' && <EgliseInfo {...{eglise}} />}
                {action === 'reset' && <EgliseReset {...{eglises:[eglise], close:()=>manage_dialog(false), showResult}} />}
                {action === 'reset_many' && <EgliseReset {...{eglises:eglises.filter(eg=>selectItems.includes(eg._id)), close:()=>manage_dialog(false), showResult}} />}
                {action === 'liaison solde' && <Box padding={3}>
                    <Typography variant="h5" fontWeight='bold' marginBottom={2}>Recalculer le solde du compte de liaison</Typography>
                    <Stack direction='row' spacing={2} paddingBottom={2}>
                        <Button variant="outlined" color="warning" onClick={()=>{manage_dialog(false); handleLaisonSoldeCalcule()}}>Recalculer</Button>
                        <Button variant="outlined" color="error" onClick={()=>{manage_dialog(false)}}>Annuler</Button>
                    </Stack>
                </Box>}

                {action === 'success' && <Box display='flex' flexDirection='column' alignItems='center' paddingBlock={3}>
                    <CheckCircle color="success" sx={{ fontSize: 120 }}/>
                    <Typography variant="h4" fontWeight='bold' color='success.main' marginBottom={2}>Opération réussie</Typography>
                </Box>}
                {action === 'echec' && <Box display='flex' flexDirection='column' alignItems='center' paddingBlock={3}>
                    <Report color="error" sx={{ fontSize: 120 }}/>
                    <Typography variant="h4" fontWeight='bold' color='error.main' marginBottom={2}>Échec de l’opération</Typography>
                </Box>}
            </Dialog>
        </Box>
    )
}